import { createTheme } from '@mui/material/styles'
import { compose } from 'redux'
import * as colors from './styleguide'
import { Theme } from '@mui/material/styles'

export enum ThemeConstants {
  LIGHT = 'LIGHT',
}

// const themeBase: ThemeOptions = {
//   props: {
//     MuiButtonBase: {
//       disableRipple: true,
//     },
//   },
// }

const makeTheme: (...args: any) => Theme = compose(createTheme)
export const themes = {
  [ThemeConstants.LIGHT]: makeTheme({
    typography: {
      // In Chinese and Japanese the characters are usually larger,
      // so a smaller fontsize may be appropriate.
      fontSize: 14,
    },
    palette: {
      type: 'light',
      primary: {
        light: colors.magenta.light,
        dark: colors.magenta.dark,
        main: colors.magenta.light,
      },
      secondary: {
        light: colors.white.light,
        dark: colors.white.dark,
        main: colors.white.light,
      },
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          body: {
            backgroundColor: colors.white.light,
          },
        },
      },
      MuiPaper: {
        root: {
          // color: colors.white.light,
        },
      },
      MuiExpansionPanelSummary: {
        root: {
          color: colors.black.light,
          backgroundColor: colors.grey.A50,
        },
      },
      MuiList: {
        root: {
          backgroundColor: colors.magenta.dark,
        },
      },
      MuiCollapse: {
        wrapper: {
          backgroundColor: colors.white.light,
          color: colors.black.light,
        },
      },
      MuiTableHead: {
        root: {
          borderBottom: '1px solid #979797',
          fontWeight: 700,
        },
      },
      MuiTableRow: {
        root: {
          borderBottom: '1px solid #979797',
          padding: '.5em',
          '&$selected': {
            backgroundColor: colors.magenta.main,
          },
          '&$selected:hover': {
            backgroundColor: colors.grey.A50,
          },
        },
      },
      MuiTableCell: {
        root: {
          borderBottom: 'none',
          padding: '.5em 1.2em',
        },
      },
      MuiIconButton: {
        root: {
          padding: '.2em',
        },
      },
      MuiButton: {
        root: {
          textTransform: 'none',
          color: colors.magenta.light,
          border: '1px solid ' + colors.magenta.light,
          padding: '.2em 1em',
          borderRadius: '8px',
          background: colors.white.light,
          '&:hover': {
            color: colors.white.light,
            backgroundColor: colors.magenta.light,
          },
          '&:disabled': {
            borderColor: colors.grey.dark,
            color: colors.white.light,
            backgroundColor: colors.grey.dark,
          },
        },
        text: {
          padding: '.2em 2.2em',
        },
      },
      MuiBackdrop: {
        root: {
          backgroundColor: 'rgba(0, 0, 0, .1)',
        },
      },
      MuiListItem: {
        root: {
          color: colors.black.light,
        },
      },
      MuiChip: {
        colorPrimary: {
          backgroundColor: colors.grey.A50,
          color: colors.black.light,
        },
        deleteIconColorPrimary: {
          color: colors.grey.light,
        },
      },
      MuiCheckbox: {
        colorSecondary: {
          color: colors.grey.light,
          '&$checked': {
            color: colors.grey.light,
          },
        },
      },
    },
  }),
}

export const keys = Object.keys(themes)

export const defaultTheme = ThemeConstants.LIGHT
